import React from 'react';
import TextInput from 'components/global/text-input';
import ContainedButton from 'components/global/buttons/contained-button';

interface IFormProps {
  handleForm: () => Promise<void>;
  amount: string;
  setAmount: React.Dispatch<React.SetStateAction<string>>;
  buttonText: string;
}

const InputRow: React.FunctionComponent<IFormProps> = ({
  handleForm,
  amount,
  setAmount,
  buttonText,
}) => {
  return (
    <div className="input-row">
      <TextInput
        value={amount}
        className="input-row-input"
        onChanged={value => setAmount(value)}
        type="number"
        placeholder="NFT Index"
      />
      <ContainedButton text={buttonText} onClick={handleForm} className="stake-button" />
    </div>
  );
};

export default InputRow;
